<template>
  <div style="padding-bottom: 20px;padding-top: 20px;">
    <span><b>{{ title }}</b></span>
    <Popper arrow class="light" :content="popover">
      <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
  </div>

  <div class="row" v-if="dataReady" style="padding-left: 20px;">
    <div class="col">
      <div v-for="(index, data) in model" :key="index" class="row">

        <div class="col">
          <ParamInput :title="$t($route.name + '.module_' + data)"
            :type="typeof model[data] === 'boolean' ? 'switch' : 'number'" :is-sub-param="true"
            :popover="$t($route.name + '.module_' + param + 'InfoPopover')" v-model="model[data]">
          </ParamInput>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import ParamInput from './ParamInput.vue';

export default {
  name: "ParamInputGroup",
  components: {
    ParamInput
  },
  props: {
    title: {
      type: String,
      default: "none",
      description: "Parameter title",
    },
    popover: {
      type: String,
      default: "",
      description: "Popover description",
    },
    modelValue: {
      type: Object,
      default: null,
      description: "Model object to be filled",
    },
  },
  data() {
    return {
      model: null,
      dataReady: false
    };
  },
  mounted() {

    this.model = this.modelValue
    this.dataReady = true
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value)
    }
  },
};
</script>
<style></style>
